import React from "react";
import CompanyRegistrationNumberValidation from "./CompanyRegistrationNumberValidation";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";

const CompanyRegistrationNumberComponent = (props) => {
  let { required, ...rest } = props;
  if (required === undefined) {
    required = true;
  }

  const isValid = (value) =>
    (!required && (!value || value.length === 0)) ||
    (value && CompanyRegistrationNumberValidation(value))
      ? undefined
      : "Please enter a valid Registration Number";

  let { name } = props;
  if (name === undefined) {
    name = "";
  }

  return (
    <Field
      name={name}
      validate={isValid}
      label="Company Registration Number"
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      inputProps={{ maxLength: 14 }}
      fullWidth
      {...rest}
    />
  );
};

export default CompanyRegistrationNumberComponent;
